import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './CurrencySelect.scss';
import { currencySigns } from 'lib/support';

export default class CurrencySelect extends Component {

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    currentCurrency: PropTypes.string.isRequired,
    availableOptions: PropTypes.object.isRequired,
    themeBackgroundColor: PropTypes.string.isRequired,
    themeLightestBgColor: PropTypes.string.isRequired
  };

  activeOptionStyle(index, numberOfOptions) {
    const { themeBackgroundColor, themeLightestBgColor  } = this.props;

    let basicStyle =  {
      backgroundColor: themeLightestBgColor,
      borderRight: `4px solid ${themeBackgroundColor}`};

    if (index === 0){
      basicStyle.borderRadius = '0 20px 0 0';
    }
    else if ( (index+1) === numberOfOptions){
      basicStyle.borderRadius = '0 0 20px 0';
    }

    return basicStyle;
  }

  render() {
    const { currentCurrency, availableOptions, themeBackgroundColor } = this.props;
    const numberOfOptions = availableOptions.size;

    return (
      <div className={styles.currencySelect} style={{borderColor: themeBackgroundColor}}>
        {availableOptions.map((option,index) => {
          return (
            <a onClick={() => this.props.onChange(option)} key={`currency-option-${option}`}>
              <div className="currencyOption"
                style={option === currentCurrency ? this.activeOptionStyle(index, numberOfOptions) : {}}>
                {option} {currencySigns[option]}
              </div>
            </a>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/snapsell/CurrencySelect.jsx